import { Resources } from 'constants/resources';

import { useQuery } from '@tanstack/react-query';
import { getReconciliationProviders } from 'config/requests/reconciliation';

export function useReconciliationProviders(merchantAlias?: string) {
  return useQuery({
    queryKey: [Resources.ReconciliationMerchants, merchantAlias, Resources.Providers],
    queryFn: () => getReconciliationProviders(merchantAlias as string),
    enabled: !!merchantAlias,
  });
}
